import { useState } from 'react';

/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-06-07 11:44:51
 * @LastEditors: 张家彬
 * @LastEditTime: 2025-01-23 16:04:43
 */
export default () => {
  const [showDeploy, setShowDeploy] = useState(false);
  const [showParamInit, setShowParamInit] = useState(false);
  const [showOrder, setShowOrder] = useState(false);

  return {
    showDeploy,
    setShowDeploy,
    showParamInit,
    setShowParamInit,
    showOrder,
    setShowOrder,
  };
};
